import Vue from 'vue';
import { mapActions } from 'vuex';
import { FETCH_SITES, SELECT_SITE } from 'src/store/types';
import BotAPI from 'src/api/chatbots';
import { BfButton } from '../Butterfly';
import slackIcon from 'assets/img/slack.svg';
import teamsIcon from 'assets/img/microsoft-teams.svg';
const IntegrationButton = Vue.extend({
    components: {
        BfButton,
    },
    props: {
        type: { type: String, required: true },
        exists: { type: Boolean, required: false, default: false },
        site: { type: String, required: true },
    },
    data() {
        return {
            loading: false,
            icons: {
                slack: slackIcon,
                teams: teamsIcon,
            },
        };
    },
    computed: {
        redirectURI() {
            const environment = process.env.APP_ENV;
            switch (environment) {
                default: return `https://localhost:8080/integration/${this.type}`;
                case 'production': return `https://app.kapiche.com/integration/${this.type}`;
                case 'staging': return `https://app.kapiche-dev.com/integration/${this.type}`;
            }
        },
        url() {
            const redirectURI = encodeURIComponent(this.redirectURI);
            // At the moment we are using the one slack app for both sharing and ingestion. Should we get requests to
            // separate these each of the scopes are defined separately.
            const shareScopes = 'app_mentions:read,chat:write,chat:write.public,channels:join,channels:read,groups:read,files:write,files:read';
            const ingestionScopes = `channels:history,channels:join,channels:read,files:read,groups:read,
      incoming-webhook,links:read,reactions:read,remote_files:read,team:read,usergroups:read,users.profile:read,
      users:read`;
            const scope = encodeURIComponent(shareScopes + ',' + ingestionScopes);
            const clientID = process.env.SLACK_BOT_CLIENT_ID;
            return `https://slack.com/oauth/v2/authorize?scope=${scope}&user_scope=&redirect_uri=${redirectURI}&client_id=${clientID}&state=${this.site}`;
        },
    },
    methods: {
        ...mapActions({
            FETCH_SITES,
            SELECT_SITE,
        }),
        async onClick(e) {
            if (!this.exists) {
                window.open(this.url, '_blank')?.focus();
                return;
            }
            e.preventDefault();
            this.loading = true;
            try {
                await BotAPI.removeIntegration(this.type);
                await this.FETCH_SITES();
                await this.SELECT_SITE({ domain: this.site });
            }
            catch (e) {
                console.error(e);
            }
            finally {
                this.loading = false;
            }
        },
    },
});
export default IntegrationButton;
